/**
 * This is the component that renders the subchapter rows in the Table of Contents.
 * It is used by the TableOfContents component.
 * @param {IChapterRow} data - The chapter data to be rendered
 * @param {boolean} [isFirst] - Whether the chapter is the first one in the list
 * @returns {React.ReactElement} A React component that displays a chapter and its subchapters
 */

import { Link, StyleSheet, Text, View } from '@react-pdf/renderer';

export interface ISubchapterItem {
  subChapterName: string;
  subChapterPage: string;
  id: string;
}

interface IChapterRow {
  data: ISubchapterItem;
  isFirst?: boolean;
}

export const ChapterRow = ({ data, isFirst = false }: IChapterRow) => (
  <View style={[styles.rowWrapper, isFirst ? styles.firstItems : styles.otherItems]} wrap={false}>
    <Link src={`#${data?.id || ''}`} style={styles.chapterText}>
      {data.subChapterName}
    </Link>
    <Text style={styles.pageNumber}>{data.subChapterPage}</Text>
  </View>
);

const styles = StyleSheet.create({
  rowWrapper: {
    height: '16px',
    width: '256px',
    display: 'flex',
    borderColor: '#77787C',
    color: '#212121',
  },
  firstItems: {
    borderTopStyle: 'dotted',
    borderTop: '0.8px',
    borderStyle: 'dotted',
    borderBottom: '0.8px',
    borderBottomStyle: 'dotted',
  },
  otherItems: {
    flexDirection: 'row',
    borderStyle: 'dotted',
    borderBottom: '0.8px',
    borderBottomStyle: 'dotted',
  },
  chapterText: {
    fontFamily: 'Noto',
    fontSize: 10,
    fontWeight: 300,
    textDecoration: 'none',
    color: '#212121',
  },
  pageNumber: {
    fontFamily: 'Noto',
    fontSize: 10,
    fontWeight: 600,
    marginLeft: 'auto',
  },
});
